import { HashRouter } from 'react-router-dom';
import { Router } from '../context/Router';

export const withHashRouter = (Component: any) => (props: any) =>
  (
    <HashRouter>
      <Component {...props} />
    </HashRouter>
  );
